<template>
  <!-- 课程列表 -->
  <div class="index-conatiner">
    <bannerImg :bannerText="bannerText" :isShowTab="true"></bannerImg>
    <div class="course-container">
      <div class="condition-box">
        <div class="left-condition">
          <el-select
            @change="typeChange()"
            class="c-list"
            v-model="courseType"
            placeholder="选择课程分类"
          >
            <el-option
              v-for="item in courseTypeList"
              :key="item.uuid"
              :label="item.title"
              :value="item.uuid"
            ></el-option>
          </el-select>
          <el-select
            @change="catalogueChange(courseCatalogue)"
            class="c-list"
            v-model="courseCatalogue"
            placeholder="选择报名等级"
          >
            <el-option
              v-for="item in catalogueList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            @change="priceChange(coursePrice)"
            class="c-list"
            v-model="coursePrice"
            placeholder="课程价格"
          >
            <el-option
              v-for="item in priceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <div @click="search" class="search-box">
            <i class="iconfont el-icon-search"></i>搜索
          </div>
          <div class="search-box reset-box" @click="reset">
            <i class="iconfont el-icon-refresh"></i>重置
          </div>
        </div>
        <div class="right-tab-box">
          <div
            class="r-tab"
            :class="tabIndex === index ? 'tab-active' : ''"
            v-for="(item, index) in tabList"
            :key="index"
            @click="tabSelect(item, index)"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="keywords-title">
        <i class="iconfont-icon icon-huo"></i>热搜关键词
      </div>
      <div class="keywords-box">
        <div
          class="k-list"
          :class="keywordsIndex === index ? 'k-active' : ''"
          v-for="(item, index) in keywordsList"
          :key="index"
          @click="keywordsSelect(item, index)"
        >
          {{ item.title }}
        </div>
      </div>
      <!-- 课程列表 -->
      <div class="course-list-box">
        <div
          class="course-list"
          v-for="(item, index) in courseList"
          :key="index"
          @click="goCourseDetail(item, index)"
        >
          <div
            class="list-img"
            :style="{ backgroundImage: 'url( ' + imgUrl + item.cover + ')' }"
          ></div>
          <div class="right-content">
            <div class="list-title">{{ item.title }}</div>
            <div class="list-detail">{{ item.desc }}</div>
            <div class="list-date">{{ item.create_time }}</div>
            <div class="list-price">
              <span v-if="item.price != '0.00'">¥</span>
              {{ item.price == "0.00" ? "免费" : item.price }}
              <!-- <span>.00</span> -->
              <span class="list-sale">已有{{ item.sales }}人已购买</span>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
        :page-size="6"
        :total="listTotal"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../api/api";
import bannerImg from "../components/bannerImg.vue";
import { imgUrl } from "../api/index";

export default {
  name: "courseList",
  components: {
    bannerImg,
  },
  data() {
    return {
      imgUrl: imgUrl,
      bannerText: "课程列表",
      courseTypeList: [], // 课程分类
      courseType: "",
      tabList: ["热门推荐", "最新上线", "学习次数"],
      tabIndex: "",
      keywordsList: [],
      keywordsIndex: 0,
      courseList: [],
      listTotal: 0,
      page_index: 1,
      is_top: false,
      is_new: false,
      sales: false,
      cate_uuid: "",
      catalogueList: [
        {
          value: 1,
          label: "普通课程",
        },
        {
          value: 2,
          label: "初级",
        },
        {
          value: 3,
          label: "中级",
        },
        {
          value: 4,
          label: "高级",
        },
      ],
      courseCatalogue: "",
      priceList: [
        {
          value: 1,
          label: "收费",
        },
        {
          value: 2,
          label: "免费",
        },
      ],
      coursePrice: "",
    };
  },
  mounted() {
    scrollTo(0, 0);
  },
  created() {
    this.getCourseList();
    this.getLiveType();
    this.getCourseCat();
  },
  methods: {
    getCourseCat() {
      api.getCourseCat().then((res) => {
        this.keywordsList = res.result;
      });
    },
    search() {
      this.getCourseList();
    },
    // 重置
    reset() {
      this.page_index = 1;
      this.page_size = 10;
      this.cate_uuid = "";
      this.exam_type = "";
      this.paper_type = "";
      this.courseType = "";
      this.courseCatalogue = "";
      this.coursePrice = "";
      this.is_charge = "";
      this.is_top = false;
      this.is_new = false;
      this.sales = false;

      this.getCourseList();
    },
    // 获取列表
    getCourseList() {
      const params = {
        page_index: this.page_index,
        page_size: 6,
        cate_uuid: this.cate_uuid,
        is_top: this.is_top,
        is_new: this.is_new,
        sales: this.sales,
        catalogue: this.courseCatalogue,
        is_charge: this.coursePrice,
      };
      api.getCourseList(params).then((res) => {
        if (res.result) {
          this.courseList = res.result.data ? res.result.data : [];
          this.listTotal = res.result.total;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 获取分类
    getLiveType() {
      api.getLiveType().then((res) => {
        this.courseTypeList = res.result;
      });
    },
    // 选择课程分类
    typeChange() {
      this.cate_uuid = this.courseType;
      this.getCourseList();
    },
    // 选择报名等级
    catalogueChange(val) {
      console.log(val);
      this.courseCatalogue = val;
      this.getCourseList();
    },
    // 课程价格选择
    priceChange(val) {
      this.coursePrice = val;
      this.getCourseList();
    },
    // 页码改变
    handleCurrentChange(val) {
      this.page_index = val;
      this.getCourseList();
    },
    // 热门推荐 最新上线 学习次数选择
    tabSelect(item, index) {
      this.tabIndex = index;
      this.is_top = false;
      this.is_new = false;
      this.sales = false;
      if (index == 0) {
        this.is_top = true;
      } else if (index == 1) {
        this.is_new = true;
      } else {
        this.sales = true;
      }
      this.getCourseList();
    },
    // 关键词选择
    keywordsSelect(item, index) {
      this.keywordsIndex = index;
      this.cate_uuid = item.uuid;
      this.getCourseList();
    },
    // 课程详情跳转
    goCourseDetail(item, index) {
      if (item.buy == 1) {
        return this.$router.push({
          path: "/myCoursePlay",
          query: { uuid: item.section_uuid },
        });
      }
      this.$router.push({
        path: "/courseDetail",
        query: { id: item.uuid },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.index-conatiner {
  min-height: 600px;
  margin-top: 122px;
}
.course-container {
  width: 72%;
  margin: 0 auto;
}
.condition-box {
  display: flex;
  justify-content: space-between;
  padding: 50px 0 40px;
  .c-list {
    margin-right: 10px;
  }
}
.left-condition {
  display: flex;
}
.search-box {
  width: 80px;
  margin-right: 12px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 36px;
  background-color: #f6ab2b;
  border: 1px solid #f6ab2b;
  border-radius: 18px;
  cursor: pointer;
  .iconfont {
    position: relative;
    top: 2px;
    padding-right: 4px;
  }
}
.reset-box {
  color: #f6ab2b;
  border: 1px solid #f6ab2b;
  background-color: #ffffff;
}
/deep/ .el-input--suffix .el-input__inner {
  height: 38px;
  line-height: 38px;
  border-radius: 18px;
}

.r-tab {
  width: 100px;
  color: #333333;
  line-height: 36px;
  text-align: center;
  border: 1px solid #d6d6d6;
  cursor: pointer;
  &:first-child {
    border: 1px solid #d6d6d6;
    border-right: none;
    border-top-left-radius: 18px;
    border-bottom-left-radius: 18px;
  }
  &:last-child {
    border: 1px solid #d6d6d6;
    border-left: none;
    border-top-right-radius: 18px;
    border-bottom-right-radius: 18px;
  }
  &:hover {
    color: #ffffff;
    border-color: #f6ab2b;
    background-color: #f6ab2b;
  }
}
.right-tab-box {
  display: flex;
  align-self: self-start;
  border-radius: 18px;
  .tab-active {
    color: #ffffff;
    border-color: #f6ab2b;
    background-color: #f6ab2b;
  }
}
.keywords-title {
  padding-bottom: 14px;
  font-size: 18px;
  color: #3f3f3f;
  border-bottom: 1px solid #ededed;
  .iconfont-icon {
    padding-right: 10px;
    font-size: 20px;
    color: #d81e06;
  }
}
.keywords-box {
  display: flex;
  flex-wrap: wrap;
  padding: 28px 0;
  border-bottom: 1px solid #ededed;
  .k-list {
    padding: 0 24px;
    margin: 0 20px 12px 0;
    color: #666666;
    line-height: 38px;
    background: #fbfbfb;
    border-radius: 20px;
    cursor: pointer;
    &:hover {
      color: #fb6d0a;
      background-color: #fef6e9;
    }
  }
  .k-active {
    color: #fb6d0a;
    background-color: #fef6e9;
  }
}
.course-list-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 48px 0 130px;
  .course-list {
    display: flex;
    // width: 664PX;
    width: calc((100% - 60px) / 2);
    padding: 20px 14px 24px 18px;
    margin-bottom: 20px;
    background: #ffffff;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 3px 15px 1px rgba(200, 200, 200, 0.35);
      .list-title,
      .list-detail {
        color: #f6ab2b;
      }
    }
  }
  .list-img {
    // flex-shrink: 0;
    width: 274px;
    height: 208px;
    background-color: #fdefe7;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .right-content {
    // flex: 1;
    // width: calc(100% - 330PX);
    width: calc(100% - 300px);
    padding: 10px 0 10px 22px;
  }
  .list-title {
    padding: 18px 0;
    font-size: 20px;
    color: #3f3f3f;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .list-detail {
    margin-bottom: 20px;
    font-size: 12px;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .list-date {
    display: inline-flex;
    padding: 0 12px;
    margin-bottom: 16px;
    font-size: 10px;
    color: #ff7b1f;
    line-height: 24px;
    background-color: #fdefe7;
    border-radius: 12px;
  }
  .list-price {
    position: relative;
    font-size: 26px;
    color: #eb2606;
    font-weight: bold;
    span {
      font-size: 14px;
    }
    .list-sale {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      padding-left: 16px;
      font-size: 12px;
      color: #929292;
      font-weight: normal;
    }
  }
}
/deep/ {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    margin-bottom: 80px;
    text-align: center;
    button {
      width: 42px;
      height: 42px;
    }
  }
  .el-pager li {
    width: 42px;
    height: 42px;
    line-height: 42px;
  }
}
@media screen and (max-width: 1600px) {
  .course-container {
    width: 96%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/courseList.vue